import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Aside from '@/view/layout/aside';
import HistoryComponent from '@/view/layout/aside/historyComponent/history.vue';
import Screenfull from '@/view/layout/screenfull';
import Search from '@/view/layout/search/search';
import Language from '@/view/layout/language';
import { mapGetters, mapActions } from 'vuex';
import CustomPic from '@/components/customPic';
import { changePassword, setUserAuthority } from '@/api/user';
export default {
  name: 'Layout',
  components: {
    Aside: Aside,
    Screenfull: Screenfull,
    Search: Search,
    CustomPic: CustomPic,
    Language: Language,
    HistoryComponent: HistoryComponent
  },
  data: function data() {
    var _this = this;
    return {
      show: false,
      isCollapse: false,
      isSider: true,
      isMobile: false,
      isShadowBg: false,
      loadingFlag: false,
      reloadFlag: true,
      value: '',
      showPassword: false,
      pwdModify: {},
      rules: {
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }, {
          min: 6,
          message: '最少6个字符',
          trigger: 'blur'
        }],
        newPassword: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }, {
          min: 6,
          message: '最少6个字符',
          trigger: 'blur'
        }],
        confirmPassword: [{
          required: true,
          message: '请输入确认密码',
          trigger: 'blur'
        }, {
          min: 6,
          message: '最少6个字符',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value !== _this.pwdModify.newPassword) {
              callback(new Error('两次密码不一致'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo', 'sideMode', 'baseColor'])), {}, {
    textColor: function textColor() {
      if (this.$store.getters['user/sideMode'] === 'dark') {
        return '#fff';
      } else if (this.$store.getters['user/sideMode'] === 'light') {
        return '#191a23';
      } else {
        return this.baseColor;
      }
    },
    backgroundColor: function backgroundColor() {
      if (this.sideMode === 'dark') {
        return '#191a23';
      } else if (this.sideMode === 'light') {
        return '#fff';
      } else {
        return this.sideMode;
      }
    },
    title: function title() {
      return this.$route.meta.title || '当前页面';
    },
    matched: function matched() {
      return this.$route.matched;
    }
  }),
  mounted: function mounted() {
    var _this2 = this;
    var screenWidth = document.body.clientWidth;
    if (screenWidth < 1000) {
      this.isMobile = true;
      this.isSider = false;
      this.isCollapse = true;
    } else if (screenWidth >= 1000 && screenWidth < 1200) {
      this.isMobile = false;
      this.isSider = false;
      this.isCollapse = true;
    } else {
      this.isMobile = false;
      this.isSider = true;
      this.isCollapse = false;
    }
    this.$bus.emit('collapse', this.isCollapse);
    this.$bus.emit('mobile', this.isMobile);
    this.$bus.on('reload', this.reload);
    this.$bus.on('showLoading', function () {
      _this2.loadingFlag = true;
    });
    this.$bus.on('closeLoading', function () {
      _this2.loadingFlag = false;
    });
    window.onresize = function () {
      return function () {
        var screenWidth = document.body.clientWidth;
        if (screenWidth < 1000) {
          _this2.isMobile = true;
          _this2.isSider = false;
          _this2.isCollapse = true;
        } else if (screenWidth >= 1000 && screenWidth < 1200) {
          _this2.isMobile = false;
          _this2.isSider = false;
          _this2.isCollapse = true;
        } else {
          _this2.isMobile = false;
          _this2.isSider = true;
          _this2.isCollapse = false;
        }
        _this2.$bus.emit('collapse', _this2.isCollapse);
        _this2.$bus.emit('mobile', _this2.isMobile);
      }();
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('user', ['LoginOut', 'GetUserInfo'])), {}, {
    changeUserAuth: function changeUserAuth(id) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return setUserAuthority({
                authorityId: id
              });
            case 1:
              res = _context.sent;
              if (res.code === 0) {
                window.location.reload();
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    reload: function reload() {
      var _this3 = this;
      this.reloadFlag = false;
      this.$nextTick(function () {
        _this3.reloadFlag = true;
      });
    },
    totalCollapse: function totalCollapse() {
      this.isCollapse = !this.isCollapse;
      this.isSider = !this.isCollapse;
      this.isShadowBg = !this.isCollapse;
      this.$bus.emit('collapse', this.isCollapse);
    },
    toPerson: function toPerson() {
      this.$router.push({
        name: 'person'
      });
    },
    savePassword: function savePassword() {
      var _this4 = this;
      this.$refs.modifyPwdForm.validate(function (valid) {
        if (valid) {
          changePassword({
            username: _this4.userInfo.userName,
            password: _this4.pwdModify.password,
            newPassword: _this4.pwdModify.newPassword
          }).then(function (res) {
            if (res.code === 0) {
              _this4.$message.success('修改密码成功！');
            }
            _this4.showPassword = false;
          });
        } else {
          return false;
        }
      });
    },
    clearPassword: function clearPassword() {
      this.pwdModify = {
        password: '',
        newPassword: '',
        confirmPassword: ''
      };
      this.$refs.modifyPwdForm.clearValidate();
    },
    changeShadow: function changeShadow() {
      this.isShadowBg = !this.isShadowBg;
      this.isSider = !!this.isCollapse;
      this.totalCollapse();
    }
  })
};